/* global ga */
import emailValidator from 'email-validator';

export const getNameError = (value) => {
  if (value === '' || value === null) {
    return 'Необходимо заполнить имя';
  } else if (/[^а-яёЁА-Я-\s]/.test(value)) {
    return 'Пожалуйста, проверьте корректность введенных данных';
  }

  return false;
};

export const getEmailError = value => {
  if (value === '' || value === null) {
    return 'Необходимо указать электронный адрес';
  } else if (!emailValidator.validate(value)) {
    return 'Пожалуйста, проверьте корректность введенных данных';
  }
};

export const checkEmail = value => getEmailError(value) === false;
export const checkName = value => getNameError(value) === false;
export const checkAgree = value => value === true;

export const convertNameCase = value =>
  value.split(' ').reduce((a, b) => {
    let reduced = a;
    if (reduced) reduced += ' ';

    if (b) {
      reduced += b[0].toUpperCase();
      if (b.length > 1) reduced += b.substring(1);
    }

    return reduced;
  }, '');

export const formValid = (data) => {
  return checkName(data.name) && !checkEmail(data.email);
};

export function initJqCode() {
  $(document).ready(() => {
    $('.selected-services__button').on('click', () => {
      $('html, body').stop().animate({
        scrollTop: $('.form-container').offset().top - 131
      }, 500, 'swing');
    });

    stickyTool();

    // $(window).scroll(stickyTool());
  });
}

export const stickyTool = () => {
  const $top = $('.form-container').offset().top - $(window).height();
  const $services = $('.selected-services');
  const $someSelected = $('.car-catalog i.isActive').length > 0;
  const $y = $(window).scrollTop();
  const $y2 = $(window).scrollTop() - $services.height();

  if ($someSelected) {
    if ($y <= $top) {
      $services.addClass('isSticky');
    }

    if ($y2 >= $top) {
      $services.removeClass('isSticky');
    }
  }
};

export function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }

  name = name.replace(/[[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const IS_PROD = window.location.hostname.match('toyota');

function getHost() {
  const presetApi = getParameterByName('api');

  if (presetApi) {
    return presetApi.match('//') ? presetApi : `https://${presetApi}`;
  }

  return IS_PROD ? 'https://serviceportal.toyota.ru' : 'https://serviceportal.toyota.ru';
}

export const host = getHost();

export const trackEvent = (params) => {
  if (window.ga && ga.getAll) {
    let trackers = {};

    ga.getAll().forEach(account => {
      let id = account.get('trackingId');

      if(!trackers[id]) {
        trackers[id] = account;

        account.send('event', {
          hitType: 'event',
          ...params,
        });
      }
    });

    // let trackers = [
    //   ga.getAll().find(i => i.b.data.values[':trackingId'] === 'UA-92885432-1'),
    //   ga.getAll().find(i => i.b.data.values[':trackingId'] === 'UA-31211135-1'),
    //   ga.getAll().find(i => i.b.data.values[':trackingId'] === 'UA-79950810-22'),
    // ].filter(i => i);

    // if (trackers.length > 0) {
    //   trackers.forEach(i => {
    //     const trackerName = i.b.data.values[':name'];

    //     if (trackerName) {
    //       ga(`${trackerName}.send`, {
    //         hitType: 'event',
    //         ...params,
    //       });
    //     }
    //   });
    // }
  }
};

export const trackInjectionEvent = (event) => {
  window.t1DataLayer = window.t1DataLayer || {};
  window.t1DataLayer.event = event;
  $(window).trigger(event.eventclass);
};



// WEBPACK FOOTER //
// ./src/libs.js